import { useContext } from 'react';

import { InAppNotificationFeedContext } from './InAppNotificationFeedProvider';

const useInAppNotificationFeed = () => {
  const inAppNotificationFeedContext = useContext(InAppNotificationFeedContext);

  if (!inAppNotificationFeedContext) {
    throw new Error(
      'useInAppNotificationFeed must be used within an InAppNotificationFeedProvider',
    );
  }

  return inAppNotificationFeedContext;
};

export default useInAppNotificationFeed;
